import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { HeaderComponent } from './header.component';

import { FontAwesomeModule, FaIconLibrary } from '@fortawesome/angular-fontawesome';
import { library } from '@fortawesome/fontawesome-svg-core';
import { fas } from '@fortawesome/free-solid-svg-icons';
import { ModalConfirmacaoMensagemModule } from '../../shared/modal-confirmacao-mensagem/modal-confirmacao-mensagem.module';


library.add(fas);

@NgModule({
  declarations: [
    HeaderComponent
  ],
  imports: [
    CommonModule,
    FontAwesomeModule,
    ModalConfirmacaoMensagemModule
  ],
  exports: [
    HeaderComponent
  ]
})
export class HeaderModule {}
